export default __webpack_public_path__ + "static/media/ART7.5d22747b.jpg";